import { render, staticRenderFns } from "./UiFunnelUrlLinker.vue?vue&type=template&id=7012ed20&scoped=true"
import script from "./UiFunnelUrlLinker.vue?vue&type=script&lang=js"
export * from "./UiFunnelUrlLinker.vue?vue&type=script&lang=js"
import style0 from "./UiFunnelUrlLinker.vue?vue&type=style&index=0&id=7012ed20&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012ed20",
  null
  
)

export default component.exports